import { classifyNarrativeFailure } from '../../lib/classifyNarrativeFailure';

/** A deployment access failure cannot be repaired by replaying every document. */
export function documentExtractionProviderBlocked(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? '');
  const { kind } = classifyNarrativeFailure({ error: message });
  return kind === 'billing-blocked' || kind === 'auth-config' || kind === 'auth-required';
}

export function documentExtractionFailureMessage(error: unknown): string {
  return (error instanceof Error ? error.message : String(error ?? 'Extraction did not complete.')).slice(0, 240);
}
